import { useReveal } from "../../lib/useReveal";

const manifestos = [
    "Não prestamos serviço.\nOperamos crescimento.",
    "Não vendemos marketing.\nConstruímos receita.",
    "Controle comercial importa.",
    "Quem controla a conversão\ncontrola o crescimento.",
];

export default function Posicionamento() {
    const ref = useReveal();
    return (
        <section
            data-testid="posicionamento"
            id="posicionamento"
            className="relative py-32 lg:py-48 border-t border-white/5 bg-[#050505] overflow-hidden"
        >
            <div className="grain-overlay" />
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1px] h-32 bg-gradient-to-b from-[#d4af37] to-transparent" />

            <div ref={ref} className="reveal max-w-7xl mx-auto px-6 lg:px-10 relative">
                <div className="flex items-center gap-4 mb-16 lg:mb-24 justify-center">
                    <span className="h-px w-10 bg-[#d4af37]" />
                    <span className="tag-fluxo">Manifesto</span>
                    <span className="h-px w-10 bg-[#d4af37]" />
                </div>

                <div className="space-y-20 lg:space-y-32">
                    {manifestos.map((m, i) => (
                        <div
                            key={i}
                            data-testid={`manifesto-${i}`}
                            className={`max-w-5xl ${
                                i % 2 === 0 ? "mr-auto text-left" : "ml-auto text-right"
                            }`}
                        >
                            <div
                                className={`flex items-center gap-4 mb-6 ${
                                    i % 2 === 0 ? "" : "justify-end"
                                }`}
                            >
                                <span className="text-[#d4af37] font-['Outfit'] text-sm tracking-[0.3em]">
                                    0{i + 1}
                                </span>
                                <span className="h-px w-14 bg-[#d4af37]/40" />
                            </div>
                            <h3 className="font-['Outfit'] font-bold uppercase text-[36px] sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.025em] whitespace-pre-line">
                                {m.split("\n").map((line, idx) => (
                                    <span key={idx} className="block">
                                        {idx === 0 ? (
                                            <span className="text-white">{line}</span>
                                        ) : (
                                            <span className="text-gold-gradient">
                                                {line}
                                            </span>
                                        )}
                                    </span>
                                ))}
                            </h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
